<template>
  <div>
    <main id="notfound" class="utb-main">
      <utb-header :linked-nav="true"></utb-header>
      <div class="container">
        <section class="container mt2-sm mt3-md">
          <div class="utb-notfound mt4-md mt7-lg">
            <p class="subhead">404 · page not found</p>
            <h1 class="h1 serif fw700 mt1-sm mt1-md">Flown off somewhere?</h1>
            <div class="fz1 fw700 mt1"><a href="/">Go back to the landing</a></div>
          </div>
          <img class="utb-balloons mt2-sm" src="@/assets/balloons@2x.png" alt="Hot Air Balloon Illustration">
        </section>
      </div>
    </main>
    <utb-footer color="light"></utb-footer>
  </div>
</template>

<script>
import UtbHeader from './Header.vue'
import UtbFooter from './Footer.vue'

export default {
  components: {
    UtbHeader: UtbHeader,
    UtbFooter: UtbFooter
  }
}
</script>

<style lang="scss">
@import '~@/styles/media';

.utb-notfound {
  grid-column: main;
  text-align: center;
  
  @include md {
    text-align: left;
    grid-column: main / span 6;
  }
}

.utb-balloons {
  width: 100%;
  grid-column: main;

  @include md {
    grid-column: 8 / span 6;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/NotFound.vue